import { cx } from "@/utils";
import { DropdownMenuLabelProps, Label } from "@radix-ui/react-dropdown-menu";

import styles from "./Dropdown.module.css";

const DropdownHeading: React.FunctionComponent<DropdownMenuLabelProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Label className={cx(styles.base, styles.heading, className)} {...props}>
      {children}
    </Label>
  );
};

export default DropdownHeading;
